import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './Chamado.css'

const Chamado = () => {
    const [chamado, setChamado] = useState({
        numero: '', tipo: '', data: '', mensagem: '', _id: ''
    })

    useEffect(() => {
        const id = window.location.pathname.slice(15)
        const url = `/api/suporte/getChamado/${id}`
        axios(url)
            .then(resp => {
                setChamado(resp.data)
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }, [])

    const arquiva = (id) => {
        const url = '/api/suporte/arquiva'
        axios.post(url, { id })
            .then(res => {
                alert(res.data)
                window.location = `/etica/meusChamados`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-headphones iconeBuscaPed"></i>
                SUPORTE
            </div>
            <div className="caixaNovoChamado">
                <div className="labelSuporte">
                    CHAMADO Nº {chamado.numero}
                </div>
                <span className='spanRespostaData'>{chamado.tipo}</span>
                <span className='spanRespostaData'>Data do chamado: {chamado.data}</span>
                <span className='spanRespostaMensagem'>Mensagem</span>
                <textarea className='textareaResposta' value={chamado.mensagem}></textarea>
                <div className="linhaResposta"></div>
                {Resposta()}
            </div>
            <button className="botaoNPed" onClick={e => arquiva(chamado._id)}>ARQUIVAR</button>
        </React.Fragment>
    )

    function Resposta() {
        if (chamado.resposta) {
            return (
                <div className="divResposta">
                    <i className="bi bi-headset iChamadoHeadSet"></i>
                    <span className='chamadoResposta'>{chamado.resposta}</span>
                </div>
            )
        } else {
            return (
                <div className="divResposta">
                    <i className="bi bi-hourglass-split iChamadoHeadSet"></i>
                    <span className='chamadoResposta'>Chamado em análise, respoderemos o mais breve possível!</span>
                </div>
            )
        }
    }
}

export default Chamado